import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    padding: 30,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    maxWidth: 450,
  },
  menu: {
    maxWidth: 350,
  },
});

const SignRiderOptions = props => {
  const signRiderSizes = [
    '24x6',
    '24x8',
    '18x6',
    `Custom (Extra charge may apply.)`,
  ];
  const signRiderMaterial = [
    'Corrugated 4mm',
    'PVC 6mm',
    'Aluminium 3mm(+$10.00 per sign)',
  ];
  const signRiderGrommetHoles = [
    'Top Only',
    'Top and Bottom',
    'No grommet holes',
  ];
  const {
    classes,
    handleChange,
    selectedSignRiderSize,
    selectedSignRiderGrommetHoles,
    selectedSignRiderMaterial,
  } = props;

  return (
    <form className={classes.container} noValidate autoComplete="off">
      <FormLabel className={classes.label}>
        Customize your sign rider.
      </FormLabel>
      <FormHelperText className={classes.helperText}>
        You can select different options for your sign rider.
      </FormHelperText>
      <TextField
        id="select-signrider-size"
        select
        label="Sign Rider Size"
        className={classes.textField}
        value={selectedSignRiderSize}
        onChange={event => {
          handleChange('selectedSignRiderSize', event.target.value);
        }}
        SelectProps={{
          MenuProps: {
            className: classes.menu,
          },
        }}
        helperText="Please select your sign rider size."
        margin="normal"
      >
        {signRiderSizes.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </TextField>
      <TextField
        id="select-signrider-material"
        select
        label="Sign Rider Material"
        className={classes.textField}
        value={selectedSignRiderMaterial}
        onChange={event => {
          handleChange('selectedSignRiderMaterial', event.target.value);
        }}
        SelectProps={{
          MenuProps: {
            className: classes.menu,
          },
        }}
        helperText="Please select your sign rider material."
        margin="normal"
      >
        {signRiderMaterial.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </TextField>
      <TextField
        id="select-signrider-grommet"
        select
        label="Grommet Holes"
        className={classes.textField}
        value={selectedSignRiderGrommetHoles}
        onChange={event => {
          handleChange('selectedSignRiderGrommetHoles', event.target.value);
        }}
        SelectProps={{
          MenuProps: {
            className: classes.menu,
          },
        }}
        helperText="Please select the desired option for grommet holes."
        margin="normal"
      >
        {signRiderGrommetHoles.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </TextField>
    </form>
  );
};

export default withStyles(styles)(SignRiderOptions);



// WEBPACK FOOTER //
// ./src/components/SignRiderOptions.js